// Constants
import { IMAGE_TYPES } from './mediaConstants';
import { ElementType } from '../elements/elementTypes';

/**
 * Gets the IMAGE_TYPE based on an element type.
 */
export const getImageTypeForElementType = (elementType: ElementType): string => {
    switch (elementType) {
        case ElementType.LINK_TYPE:
            return IMAGE_TYPES.LINK;
        case ElementType.BOARD_TYPE:
            return IMAGE_TYPES.BOARD;
        case ElementType.FILE_TYPE:
            return IMAGE_TYPES.FILE;
        default:
            return IMAGE_TYPES.ELEMENT;
    }
};
